import React from 'react'
import { Link } from 'react-router-dom'

function CommitCodeEthic({ title = "", description = "", buttonName = "", pathname = "", onClick = null }) {
    return (
        <section className="w-full bg-gradient-radial py-2 lg:py-2">
            <div className="container mx-auto px-4 lg:px-24">
                <div className='flex flex-col items-center'>
                    <div className='w-full md:w-[90%] flex flex-col items-center gap-6 mb-4'>
                        <h2
                            className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                            {title}
                        </h2>
                        <p className="text-sm text-center sm:text-base lg:text-xl font-urbanist text-stone-300">
                            {description}
                        </p>
                        {
                            !!buttonName && (
                                <Link to={pathname} onClick={onClick} className="group flex items-center bg-white border border-gray-300 text-gray-900 font-medium p-[0.15rem] rounded-full rounded-tr-lg shadow-sm hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <span className='px-6 font-urbanist md:text-2xl text-xl group-hover:scale-105'>{buttonName}</span>
                                    <span className="flex items-center justify-center w-8 h-8 rounded-full p-1 rounded-tr-lg border-2 transition border-black group-hover:bg-black group-hover:scale-105">
                                        <img className="group-hover:invert group-hover:text-white transition-transform" src="/assets/services/1/arrow-right.png" alt="arrow-right" />
                                    </span>
                                </Link>

                            )
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CommitCodeEthic